import styled from "styled-components";

export const ModalLabel = styled('div')`
  display: inline-block;
  background-color: #FFF3E0;
  color: #F57C00;
  font-size: 11px;
  font-weight: 700;
  padding: 5px 10px;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
`;

export const ModalTitle = styled('h2')`
  font-size: 26px;
  font-weight: 600;
  color: #212121;
  line-height: 1.3;
  margin-bottom: 4px;
  margin-top: 0;
`;

export const ModalMessage = styled('div')`
  font-size: 14px;
  color: #616161;
  line-height: 1.7;

  p {
    margin-bottom: 14px;
    margin-top: 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    color: #424242;
    font-weight: 600;
  }
`;

export const ModalActions = styled('div')`
  display: flex;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #E0E0E0;
  justify-content: center;
  margin-top: 20px;
`;

